import { render } from "./Forms_AI_PopUp.vue?vue&type=template&id=af8f6c36&scoped=true"
import script from "./Forms_AI_PopUp.js?vue&type=script&lang=js"
export * from "./Forms_AI_PopUp.js?vue&type=script&lang=js"

import "./Forms_AI_PopUp.vue?vue&type=style&index=0&id=af8f6c36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8f6c36"]])

export default __exports__